import useResponsive from '@/hooks/useResponsive';
import { FC, ReactNode, useState } from 'react';
import SidebarContext from './SidebarContext';

export const SidebarProvider: FC<{
  children: ReactNode;
}> = ({ children }) => {
  const [showOnMobile, setShowOnMobile] = useState(false);
  const toggleShowOnMobile = () => {
    setShowOnMobile((current) => !current);
  };
  const resetShowOnMobile = () => {
    setShowOnMobile(false);
  };
  useResponsive(undefined, resetShowOnMobile);

  return (
    <SidebarContext.Provider value={{ showOnMobile, toggleShowOnMobile }}>
      {children}
    </SidebarContext.Provider>
  );
};
